import React, { useState } from "react";
import { Button, Card, Collapse, Table } from "antd";
import { TableWrapper } from "../../container/styled";

const { Panel } = Collapse;

const ComparisonTable = ({ data }) => {
  // Getting all spec and sub-specs in the same array
  const specCategories = [];

  data.forEach((product) => {
    product.tableData.forEach((category) => {
      const existing = specCategories.find(
        (item) => item.key === category.title
      );

      if (!existing) {
        specCategories.push({
          key: category.title,
          subSpecs: category.content.map((item) => item.title),
        });
      } else {
        category.content.forEach((item) => {
          if (!existing.subSpecs.includes(item.title)) {
            existing.subSpecs.push(item.title);
          }
        });
      }
    });
  });

  // Generate rows for each sub-spec
  const generateRows = (category) => {
    return category.subSpecs.map((subSpecTitle) => {
      const row = {
        subSpec: subSpecTitle,
      };

      data.forEach((product) => {
        const productId = product.productId;
        const matchingCategory = product.tableData.find(
          (c) => c.title === category.key
        );
        const matchingSubSpec = matchingCategory?.content.find(
          (contentItem) => contentItem.title === subSpecTitle
        );

        row[productId] = matchingSubSpec?.value || "-";
      });

      return row;
    });
  };

  const [activeKeys, setActiveKeys] = useState(
    specCategories.length > 4
      ? specCategories.slice(0, 4).map((cat) => cat.key)
      : specCategories.map((cat) => cat.key)
  );

  // Table columns for each category
  const getColumns = () => {
    return [
      {
        title: "Specifications",
        dataIndex: "subSpec",
        className: "subspec-column",
        key: "subSpec",
        width: 150,
        fixed: "left",
        render: (text) => <strong>{text}</strong>,
      },
      ...data.map((product) => ({
        title: product.productName,
        dataIndex: product.productId,
        key: product.productId,
        width: 250,
        align: "left",
      })),
    ];
  };

  const expandAll = () => {
    setActiveKeys(specCategories.map((category) => category.key));
  };

  const collapseAll = () => {
    setActiveKeys([]);
  };

  const handlePanelChange = (keys) => {
    setActiveKeys(keys);
  };

  return (
    <Card
      title="PRODUCT SPECIFICATION"
      style={{
        borderRadius: 24,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
        padding: 12
      }}
      className="specs"
      extra={
        <div style={{ marginBottom: 12 }}>
          <Button type="primary" onClick={expandAll} style={{ marginRight: 8 }}>
            Expand All
          </Button>
          <Button type="primary" onClick={collapseAll}>
            Collapse All
          </Button>
        </div>
      }
    >

      <Collapse activeKey={activeKeys} onChange={handlePanelChange}>
        {specCategories.map((category) => (
          <Panel
            header={category.key}
            key={category.key}
            className="customPanel"
          >
            <Table
              columns={getColumns()}
              dataSource={generateRows(category)}
              pagination={false}
              bordered
              scroll={{ x: true }}
              className="comparison-table"
              size="small"
              rowKey={(record) => record.subSpec}
            />
          </Panel>
        ))}
      </Collapse>

      <style>{`
        .customPanel .ant-collapse-header-text {
            color: #f4f4f4;
        }
        .comparison-table .subspec-column {
          background-color: #f0f5ff;
          font-weight: 600;
          color: #003a8c;
        }
        .comparison-table .ant-table-thead > tr > th {
          background-color: #2f6cc0;
          color: #f4f4f4;
        }
        .comparison-table .ant-table-cell {
          padding: 5px !important;
        }
        .ant-collapse-header {
          font-weight: 600;
          background-color: #2f6cc0;
          color: #fff;
        }
        .ant-collapse-content-box {
          padding: 10px;
        }
        @media (max-width: 512px) {
          .specs .ant-card-head-wrapper{
            flex-direction:column;
          }
          .specs .ant-card-extra{
              margin-inline-start:0;
          }
        }
      `}</style>
    </Card>
  );
};

export default ComparisonTable;
